import React from 'react'
import {
  Intl as IntlError,
  loadLanguage as loadLanguageError,
  Provider as LocalizationProviderError,
} from '@eversports/core-io/localization/react'
import {
  Intl as IntlComponents,
  loadLanguage as loadLanguageComponents,
  Provider as LocalizationProviderComponents,
} from '@eversports/react-components/localization/react'
import {
  Intl as IntlKlimtPatterns,
  loadLanguage as loadKlimtPatternsLanguage,
  Provider as KlimtPatternsLocalizationProvider,
} from '@eversports/klimt-patterns/localization/react'
import {
  Intl as IntlUserComponents,
  loadLanguage as loadUserComponentsLanguage,
  Provider as UserComponentsLocalizationProvider,
} from '@eversports/user-components/localization/react'

import {
  Intl as IntlCheckout,
  loadLanguage as loadLanguageCheckout,
  Locales,
  Provider as LocalizationProviderCheckout,
} from '../localization/react'

interface Props {
  intlCheckout: IntlCheckout
  intlError: IntlError
  intlComponents: IntlComponents
  intlKlimtPatterns: IntlKlimtPatterns
  intlUserComponents: IntlUserComponents
}

const CheckoutLocalizationProvider: React.FC<React.PropsWithChildren<Props>> = ({
  intlCheckout,
  intlError,
  intlComponents,
  intlKlimtPatterns,
  intlUserComponents,
  children,
}) => (
  <LocalizationProviderCheckout value={intlCheckout}>
    <LocalizationProviderError value={intlError}>
      <LocalizationProviderComponents value={intlComponents}>
        <KlimtPatternsLocalizationProvider value={intlKlimtPatterns}>
          <UserComponentsLocalizationProvider value={intlUserComponents}>{children}</UserComponentsLocalizationProvider>
        </KlimtPatternsLocalizationProvider>
      </LocalizationProviderComponents>
    </LocalizationProviderError>
  </LocalizationProviderCheckout>
)

async function getLocalizationProvider(locale: Locales): Promise<React.FC<React.PropsWithChildren<unknown>>> {
  const [intlCheckout, intlError, intlComponents, intlKlimtPatterns, intlUserComponents] = await Promise.all([
    loadLanguageCheckout(locale),
    loadLanguageError(locale),
    loadLanguageComponents(locale),
    loadKlimtPatternsLanguage(locale),
    loadUserComponentsLanguage(locale),
  ])

  // eslint-disable-next-line react/display-name
  return (props) => (
    <CheckoutLocalizationProvider
      intlCheckout={intlCheckout}
      intlError={intlError}
      intlComponents={intlComponents}
      intlKlimtPatterns={intlKlimtPatterns}
      intlUserComponents={intlUserComponents}
      {...props}
    />
  )
}

export default getLocalizationProvider
